export default "__VITE_ASSET__DiLqrdrg__"